import { render, staticRenderFns } from "./zhfw.vue?vue&type=template&id=0ac52ca3&scoped=true&"
import script from "./zhfw.vue?vue&type=script&lang=ts&"
export * from "./zhfw.vue?vue&type=script&lang=ts&"
import style0 from "./zhfw.vue?vue&type=style&index=0&id=0ac52ca3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ac52ca3",
  null
  
)

export default component.exports